export const SELECT_CREDIT_MANAGER_DATA = 'SELECT_CREDIT_MANAGER_DATA';
export const SELECT_CREDIT_MANAGER_DATA_ATTRIBUTE = 'creditManagerContainer';
export const RESET_CREDIT_MANAGER_CONTAINER_DATA =
  'RESET_CREDIT_MANAGER_CONTAINER_DATA';
